import { GetterTree } from 'vuex';
import { IDealroomState } from '@/dealroom/store/dealroom.store';
import { RootState } from '@/store/store';
import { EEditorContentGetter } from '@/editor/editor-block/store/editor-content.constants';
import { ICell, IField, INode, IRow, ISection, ITable, IText } from '@/editor/types';
import { IDocumentPage } from '@/types/document-page';
import { EDocumentPageType } from '@/enums/document-page-type';
import { ENodeType } from '@/editor/types/enums';

export const getters: GetterTree<IDealroomState, RootState> = {
  [EEditorContentGetter.AllEditorFields](state: IDealroomState): IField[] {
    return state.document.pages
      .filter(({ pageType }: IDocumentPage) => pageType === EDocumentPageType.Editor)
      .map(({ editorBlock }: IDocumentPage) => editorBlock.content.sections)
      .reduce((a: ISection[], b: ISection[]) => a.concat(b), [])
      .map(({ rows }: ISection) => rows)
      .reduce((a: IRow[], b: IRow[]) => a.concat(b), [])
      .map(({ cells }: IRow) => cells)
      .reduce((a: ICell[], b: ICell[]) => a.concat(b), [])
      .map(({ nodes }: ICell) => nodes)
      .reduce((a: INode[], b: INode[]) => a.concat(b), [])
      .filter(({ type }: INode) => type === ENodeType.Table || type === ENodeType.Text)
      .map(({ fields }: IText | ITable) => fields)
      .reduce((a: IField[], b: IField[]) => a.concat(b), []);
  },
};
